/**
 * Órdenes en proceso (`status=completado`, listas para entregar). Reemplaza el
 * placeholder de `ROUTES.ordersInProcess`. Equivale a `completed_orders.html`.
 */
import { OrdersListScreen } from "./OrdersListScreen";

export function OrdersInProcessScreen() {
  return <OrdersListScreen status="completado" title="Órdenes en proceso" />;
}
